$(document).ready(function(){
    $('.block__ai-work-item').each(function(elm){
        setTimeout(()=>{
            if(window.innerWidth > 768){
                 let height_right =  $(this).find('.block__ai-work-item-slider-left-desk-wrapper').innerHeight() + $(this).find('.block__ai-work-item-left-bottom').innerHeight() + 40; 
                 $(this).find('.block__ai-work-item-slider-right').css('height', height_right); 
            }
        }, 2000)
    }); 

$('.block__ai-work-wrapper').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: $(".block__ai-work-next"),
            prevArrow: $(".block__ai-work-prev"), 
            customPaging: function() { return '<button></button>'; }, 
            dots: true, 
            arrows: true,
            fade: true,
            adaptiveHeight: true
    });
        $(".column_list_one").slick({
    draggable: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true
  });
              $(".column_list_two").slick({
    draggable: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 0,
    speed: 6000,
    pauseOnHover: false,
    cssEase: 'linear',
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true
  });
    if(window.innerWidth < 768){
         $(".block__ai-work-item-marquee-text-wrapper").slick({
            draggable: false,
            infinite: true,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 0,
            speed: 5000,
            pauseOnHover: false,
            cssEase: 'linear',
            variableWidth: true
        });
    }
}) 

